import React from 'react';
import { AlertTriangleIcon, XCircleIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="flex flex-col w-full bg-gray-light py-20 px-4" data-id="element-106">
      <div className="max-w-4xl mx-auto" data-id="element-107">
        <div className="text-center mb-12" data-id="element-108">
          <div className="flex justify-center mb-4" data-id="element-109">
            <AlertTriangleIcon className="w-12 h-12 text-red-500" data-id="element-110" />
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy mb-6" data-id="element-111">
            El Error Que Cometen Miles de Personas al Intentar Construir Crédito
          </h2>
          <p className="text-xl text-text-muted" data-id="element-112">
            La mayoría de los latinos en Estados Unidos pierden años de progreso
            financiero simplemente porque nadie les explicó las reglas del
            juego.
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-10 border-t-4 border-red-500" data-id="element-113">
          <div className="space-y-6" data-id="element-114">
            <div className="flex items-start" data-id="element-115">
              <XCircleIcon className="text-red-500 w-6 h-6 flex-shrink-0 mr-4 mt-1" data-id="element-116" />
              <p className="text-lg text-text-dark" data-id="element-117">
                <strong data-id="element-118">Solicitan las tarjetas equivocadas:</strong> Aplican a
                bancos que exigen historial previo y son rechazados, lo que daña
                su perfil antes de empezar.
              </p>
            </div>

            <div className="flex items-start" data-id="element-119">
              <XCircleIcon className="text-red-500 w-6 h-6 flex-shrink-0 mr-4 mt-1" data-id="element-120" />
              <p className="text-lg text-text-dark" data-id="element-121">
                <strong data-id="element-122">Usan mal el crédito disponible:</strong> Gastan más del
                porcentaje recomendado, hundiendo su score sin darse cuenta.
              </p>
            </div>

            <div className="flex items-start" data-id="element-123">
              <XCircleIcon className="text-red-500 w-6 h-6 flex-shrink-0 mr-4 mt-1" data-id="element-124" />
              <p className="text-lg text-text-dark" data-id="element-125">
                <strong data-id="element-126">No entienden cómo funciona el algoritmo:</strong> Creen
                que pagar en efectivo es mejor, volviéndose "invisibles" para el
                sistema financiero.
              </p>
            </div>

            <div className="flex items-start" data-id="element-127">
              <XCircleIcon className="text-red-500 w-6 h-6 flex-shrink-0 mr-4 mt-1" data-id="element-128" />
              <p className="text-lg text-text-dark" data-id="element-129">
                <strong data-id="element-130">Pierden años avanzando lentamente:</strong> Terminan
                pagando miles de dólares extra en intereses por autos o casas
                debido a un score bajo o inexistente.
              </p>
            </div>
          </div>

          <div className="mt-10 bg-red-50 p-6 rounded-xl border border-red-100" data-id="element-131">
            <p className="text-xl font-bold text-red-700 text-center" data-id="element-132">
              Resultado: Frustración, rechazos constantes y la sensación de
              estar atrapado financieramente.
            </p>
          </div>
        </div>
      </div>
    </section>;
}